import CardWidget from './CardWidget';
import { Config } from './types';
import CardWidgetControl from './CardWidgetControl';
import {
  defaultBackgroundData,
  defaultBackgroundImageData,
  defaultBorderData,
  widgetTypes,
} from 'builder/util/constants';

export default {
  type: widgetTypes.Card,
  displayName: 'Card',
  icon: 'cards-blank',
  initialConfig: {
    ...defaultBackgroundData,
    ...defaultBackgroundImageData,
    borderData: {
      ...defaultBorderData.borderData,
      radius: 5,
    },
    width: 420,
    height: 580,
    xLocation: 10,
    yLocation: 10,
    uniqueId: 'card345',
    lineColor: '#828485',
    visible: true,
  },
  components: {
    render: CardWidget,
    control: CardWidgetControl,
  },
  copyable: true,
} as HorizonWidgetDefinition<Config>;
